import type {GlobalUtils} from "@otto-ec/global-resources";
import type {Mustache} from "@otto-ec/global-resources/dist-lib/exports/mustache";

import {Util, util} from "./helper/util";
import {searchbar, searchForm, SearchHandler, searchHandler} from "./searchbar";
import {suggestTracking, TrackSessionStart} from "./tracking";
import {Features, initFeatureFlags} from "./helper";
import {searchSuggest, suggestLayer} from "./suggest";
import {searchHistory, submitHistory} from "./history";
import {emptyStateSuggest} from "./emptyState";
import {navSlider} from "././ftnav/NavSlider";

/*                                                        */

export interface Squirrel extends Features {
  searchbar: typeof searchbar;
  searchHandler: SearchHandler;
  searchSuggest: typeof searchSuggest;
  suggestTracking: typeof suggestTracking;
  util: Util;
  searchForm: typeof searchForm;
  submitHistory: typeof submitHistory;
  searchHistory: typeof searchHistory;
  emptyStateSuggest: typeof emptyStateSuggest;
  suggestLayer: typeof suggestLayer;
  navSlider: typeof navSlider;
}

declare global {
  interface Window {
    o_squirrel: Squirrel;
    o_util: GlobalUtils;
    Mustache: typeof Mustache;
    squirrelTrackingInitialized: boolean;
  }
}

window.o_squirrel ||= {} as never;

initFeatureFlags(window.o_squirrel);

window.o_squirrel.util = util;
window.o_squirrel.searchForm = searchForm;
window.o_squirrel.searchHandler = searchHandler;
window.o_squirrel.searchSuggest = searchSuggest;
window.o_squirrel.searchbar = searchbar;
window.o_squirrel.suggestTracking = suggestTracking;
window.o_squirrel.submitHistory = submitHistory;
window.o_squirrel.searchHistory = searchHistory;
window.o_squirrel.emptyStateSuggest = emptyStateSuggest;
window.o_squirrel.suggestLayer = suggestLayer;
window.o_squirrel.navSlider = navSlider;

window.o_squirrel.searchbar();
window.o_squirrel.searchHandler.init();

TrackSessionStart.init();
